import React from "react"
import cn from "classnames";
import SelectField from "./SelectField"
import TextField from "./TextField"
import { PhoneCodeOptionKey, phoneCodeOptions } from "../../data/countries"
import { UserProfile } from "../../types/user"

const optionTypeByProfile = (profile?: UserProfile): PhoneCodeOptionKey => {
  return (!profile || profile.role === "investor") ? "all" : "borrowerDigiAuth";
}

interface Props {
  className?: string;
  countryCodeFieldName?: string;
  disabled?: boolean;
  fieldClass?: string;
  optionType?: PhoneCodeOptionKey;
  prefix?: string;
  profile?: UserProfile;
  small?: boolean;
  hasLabel?: boolean;
}

const PhoneNumberFields = (props: Props): JSX.Element => {
  const { countryCodeFieldName = "phoneCountryCode", disabled, profile, prefix = "", small = false, hasLabel } = props;
  const optionType = props.optionType || optionTypeByProfile(profile);
  return (
    <div className={cn("DoubleFieldGroup", props.className)}>
      <SelectField
        className={cn("mt-5", props.fieldClass)}
        disabledWithValue={disabled ? profile?.phoneCountryCode : ""}
        i18nKey="attributes.country_code"
        id="field_phone_country_code"
        name={`${prefix}${countryCodeFieldName}`}
        options={phoneCodeOptions[optionType]}
        small={small}
        hasLabel={hasLabel}
      />
      <TextField
        className={cn("mt-5", props.fieldClass)}
        disabledWithValue={disabled ? profile?.phoneNumber : ""}
        i18key="attributes.phone_number"
        id="field_phone_number"
        name={`${prefix}phoneNumber`}
        small={small}
        hasLabel={hasLabel}
      />
    </div>
  )
}

export default PhoneNumberFields
